import { useMemo } from 'react';
import { LocalMakeSortingField } from '../../../api/types';
import makeGetSortingRule from '../../../utilities/makeGetSortingRule';

export const getSortField = makeGetSortingRule((field): LocalMakeSortingField => {
    switch (field) {
        case 'module.company.displayName':
            return LocalMakeSortingField.Company;

        case 'identifier':
            return LocalMakeSortingField.Identifier;

        case 'name':
            return LocalMakeSortingField.Name;

        case 'order':
            return LocalMakeSortingField.Order;

        case 'isActive':
            return LocalMakeSortingField.IsActive;

        default:
            throw new Error('Unknown Sorting Field!');
    }
});

const useSortOrder = sort => {
    const companySort = useMemo(
        () => (sort.field === LocalMakeSortingField.Company ? sort.orderValue : undefined),
        [sort]
    );

    const identifierSort = useMemo(
        () => (sort.field === LocalMakeSortingField.Identifier ? sort.orderValue : undefined),
        [sort]
    );

    const nameSort = useMemo(() => (sort.field === LocalMakeSortingField.Name ? sort.orderValue : undefined), [sort]);

    const orderSort = useMemo(() => (sort.field === LocalMakeSortingField.Order ? sort.orderValue : undefined), [sort]);

    const activeSort = useMemo(
        () => (sort.field === LocalMakeSortingField.IsActive ? sort.orderValue : undefined),
        [sort]
    );

    return {
        companySort,
        identifierSort,
        nameSort,
        orderSort,
        activeSort,
    };
};

export default useSortOrder;
